"use client";

import { useState } from "react";
import Link from "next/link";
import Image from "next/image";
import {
    Activity,
    BadgeCheck,
    BarChart,
    BarChart3,
    Bot,
    BrainCircuit,
    ChevronLeft,
    ChevronRight,
    ClipboardCheck,
    Cloud,
    Code2,
    Coffee,
    Cpu,
    Database,
    DatabaseZap,
    Dna,
    FlaskConical,
    FolderCode,
    GraduationCap,
    Lightbulb,
    LineChart,
    MessageSquareText,
    Monitor,
    Network,
    Quote,
    RefreshCw,
    Settings,
    Shield,
    ShieldCheck,
    Signpost,
    Sparkles,
    TrendingUp,
    WandSparkles,
    Workflow,
    Zap,
} from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import { testimonialsData } from "@/data/testimonialsData";

const displayTestimonials = testimonialsData.slice(0, 3);
const categoryIconClass = "h-4 w-4 text-[#1B61FF]";

const popularCategories = [
    { label: "Power BI",              href: "/courses/power-bi",              icon: <BarChart3 className={categoryIconClass} /> },
    { label: "Salesforce",            href: "/courses/salesforce-administrator", icon: <Cloud className={categoryIconClass} /> },
    { label: "Cybersecurity",         href: "/courses/cybersecurity",          icon: <ShieldCheck className={categoryIconClass} /> },
    { label: "Python",                href: "/courses/python",                 icon: <Code2 className={categoryIconClass} /> },
    { label: "Data Warehousing",      href: "/courses/data-warehousing",       icon: <Database className={categoryIconClass} /> },
    { label: "SAS",                   href: "/courses/sas-statistical-analysis", icon: <Dna className={categoryIconClass} /> },
    { label: "Java",                  href: "/courses/java",                   icon: <Coffee className={categoryIconClass} /> },
    { label: "PMP",                   href: "/courses/pmp",                    icon: <ClipboardCheck className={categoryIconClass} /> },
    { label: "Agile Scrum",           href: "/courses/agile-scrum-master",     icon: <RefreshCw className={categoryIconClass} /> },
    { label: "QA Testing",            href: "/courses/qa-testing",             icon: <BadgeCheck className={categoryIconClass} /> },
    { label: "Business Analysis",     href: "/courses/business-analysis",      icon: <LineChart className={categoryIconClass} /> },
    { label: "ServiceNow",            href: "/courses/servicenow",             icon: <Settings className={categoryIconClass} /> },
    { label: "Linux",                 href: "/courses/linux-administration",   icon: <Monitor className={categoryIconClass} /> },
    { label: "Selenium",              href: "/courses/selenium",               icon: <Bot className={categoryIconClass} /> },
    { label: "Tableau",               href: "/courses/tableau",                icon: <TrendingUp className={categoryIconClass} /> },

    { label: "Deep Learning",         href: "/courses/deep-learning",          icon: <BrainCircuit className={categoryIconClass} /> },
    { label: "Deep Learning with TensorFlow", href: "/courses/deep-learning-with-tensorflow", icon: <Network className={categoryIconClass} /> },
    { label: "Future Of Work With AI", href: "/courses/future-of-work-with-ai", icon: <Sparkles className={categoryIconClass} /> },
    { label: "Generative AI For Software Development", href: "/courses/generative-ai-for-software-development", icon: <WandSparkles className={categoryIconClass} /> },
    { label: "Machine Learning",      href: "/courses/machine-learning",       icon: <Cpu className={categoryIconClass} /> },
    { label: "Machine Learning Engineer", href: "/courses/machine-learning-engineer", icon: <GraduationCap className={categoryIconClass} /> },
    { label: "Machine Learning Scientist", href: "/courses/machine-learning-scientist", icon: <FlaskConical className={categoryIconClass} /> },
    { label: "Natural Language Processing", href: "/courses/natural-language-processing", icon: <MessageSquareText className={categoryIconClass} /> },
    { label: "Robotic Process Automation (RPA)", href: "/courses/robotic-process-automation-rpa", icon: <Workflow className={categoryIconClass} /> },
    { label: "UIPath", href: "/courses/uipath", icon: <Bot className={categoryIconClass} /> },

    { label: "AWS", href: "/courses/aws", icon: <Bot className={categoryIconClass} /> },
    { label: "Cyber Security", href: "/courses/cybersecurity", icon: <Shield className={categoryIconClass} /> },
    { label: "Data Analytics", href: "/courses/data-analytics", icon: <BarChart className={categoryIconClass} /> },
    { label: "Data Engineering On Microsoft Azure", href: "/courses/data-engineering-on-microsoft-azure", icon: <DatabaseZap className={categoryIconClass} /> },
    { label: "DevOps Interview Questions", href: "/courses/devops-interview-questions", icon: <Bot className={categoryIconClass} /> },

    { label: "Full Stack Developer ", href: "/courses/fullstackdeveloper", icon: <FolderCode className={categoryIconClass} /> },
    { label: "Guidewire", href: "/courses/guidewire", icon: <Signpost className={categoryIconClass} /> },
    { label: "Hanna Administration", href: "/courses/hana-administration", icon: <Bot className={categoryIconClass} /> },
    { label: "Healthcare QNXT", href: "/courses/healthcare-qnxt", icon: <Activity className={categoryIconClass} /> },
    { label: "Java Full Stack Developer ", href: "/courses/java-fullstack-developer", icon: <Bot className={categoryIconClass} /> },

    { label: "Linux Devops ", href: "/courses/linux-devops", icon: <Bot className={categoryIconClass} /> },
    { label: "Microsoft Dynamics 365 Finance and Operations ", href: "/courses/microsoft-dynamics-365", icon: <Bot className={categoryIconClass} /> },
    { label: "MS-SQL", href: "/courses/ms-sql", icon: <Bot className={categoryIconClass} /> },
    { label: "MULESOFT", href: "/courses/mule-soft", icon: <Bot className={categoryIconClass} /> },
    { label: "NETSUITE", href: "/courses/net-suite", icon: <Bot className={categoryIconClass} /> },
    { label: "Oracle DBA", href: "/courses/oracle-db", icon: <Database className={categoryIconClass} /> },
    { label: "PeopleSoft Financials", href: "/courses/peoplesoft-financials", icon: <Bot className={categoryIconClass} /> },
    { label: "PowerShell", href: "/courses/power-shell", icon: <Zap className={categoryIconClass} /> },

    
    { label: "Web Methods", href: "/courses/webMethods", icon: <Bot className={categoryIconClass} /> },
    { label: "SharePoint Admin", href: "/courses/share-point-admin", icon: <Bot className={categoryIconClass} /> },
    { label: "SAP S/4HANA", href: "/courses/saps-4hanna", icon: <Bot className={categoryIconClass} /> },
    { label: "SAP HCM", href: "/courses/sap-hcm", icon: <Bot className={categoryIconClass} /> },
    { label: "SAP GRC", href: "/courses/sap-grc", icon: <Bot className={categoryIconClass} /> },
    { label: "SAP EWM", href: "/courses/sap-ewm", icon: <Bot className={categoryIconClass} /> },
    { label: "SAP BTP", href: "/courses/sap-btp", icon: <Bot className={categoryIconClass} /> },
    { label: "SAP Basis", href: "/courses/sap-basis", icon: <Bot className={categoryIconClass} /> },
    { label: "SAP Ariba", href: "/courses/sap-ariba", icon: <Bot className={categoryIconClass} /> },
    { label: "SailPoint", href: "/courses/sail-point", icon: <Bot className={categoryIconClass} /> }




];

const rows = [
    popularCategories.slice(0, 56),
    // popularCategories.slice(25, 35),
];

function StarRating({ rating }: { rating: number }) {
    return (
        <div className="flex items-center gap-0.5 mb-4">
            {Array.from({ length: 5 }).map((_, i) => (
                <svg key={i} width="16" height="16" viewBox="0 0 24 24" fill={i < rating ? "#FBBF24" : "none"} stroke="#FBBF24" strokeWidth="1.5">
                    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                </svg>
            ))}
        </div>
    );
}

export function Testimonials() {
    const [activeIndex, setActiveIndex] = useState(0);

    const next = () => setActiveIndex((prev) => (prev + 1) % displayTestimonials.length);
    const prev = () => setActiveIndex((prev) => (prev - 1 + displayTestimonials.length) % displayTestimonials.length);

    return (
        <section className="py-6 sm:py-2 bg-white overflow-hidden">
            <div className="max-w-[1440px] mx-auto px-4 md:px-8 lg:px-12">
                <div className="flex flex-col lg:flex-row items-center gap-16 lg:gap-24 mb-24">
                    {/* Left Side - Arched Image */}
                    <motion.div
                        initial={{ opacity: 0, x: -50 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.8 }}
                        className="flex-1 relative w-full hidden sm:flex"
                    >
                        <div className="relative w-full max-w-[500px] h-[360px] sm:h-[520px] mx-auto">
                            {/* Arch Background */}
                            <div className="absolute inset-x-0 bottom-0 top-[15%] bg-[#DDE6FF] rounded-t-[80px] sm:rounded-t-[180px] lg:rounded-t-[240px]" />

                            {/* Main Image */}
                            <div className="absolute inset-0 z-10 sm:overflow-hidden sm:rounded-t-[180px] lg:rounded-t-[240px]">
                                <Image
                                    src="/images/testimonials-main.png"
                                    alt="Student pointing"
                                    fill
                                    className="object-contain object-bottom sm:scale-110 sm:-translate-y-[5%] sm:-translate-x-[-5%]"
                                />
                            </div>

                            {/* Decorative Star */}
                            <motion.div
                                initial={{ opacity: 0, rotate: -45, scale: 0.5 }}
                                whileInView={{ opacity: 1, rotate: 0, scale: 1 }}
                                viewport={{ once: true }}
                                transition={{ delay: 0.5, duration: 0.6 }}
                                className="absolute top-[12%] right-[8%] z-20"
                            >
                                {/* <svg width="72" height="72" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" className="drop-shadow-lg">
                                    <path d="M32 0L36.5 22.5L59 27L36.5 31.5L32 54L27.5 31.5L5 27L27.5 22.5L32 0Z" fill="#FF9F43" />
                                    <path d="M47.5 11.5L40.5 27.5L56.5 34.5L40.5 41.5L47.5 57.5L31.5 50.5L15.5 57.5L22.5 41.5L6.5 34.5L22.5 27.5L15.5 11.5L31.5 18.5L47.5 11.5Z" fill="#FF9F43" />
                                </svg> */}
                            </motion.div>

                            {/* Floating Avatar */}
                            {/* <motion.div
                                initial={{ opacity: 0, scale: 0.8 }}
                                whileInView={{ opacity: 1, scale: 1 }}
                                viewport={{ once: true }}
                                transition={{ delay: 0.8, duration: 0.5 }}
                                className="absolute top-[32%] left-0 sm:-left-10 z-20 w-20 h-20 sm:w-28 sm:h-28 rounded-full border-[6px] sm:border-[8px] border-white shadow-2xl overflow-hidden bg-white"
                            >
                                <Image src="/images/circle-img.jpg" alt="Badge" fill className="object-cover" />
                            </motion.div> */}
                        </div>
                    </motion.div>

                    {/* Right Side - Carousel Content */}
                    <motion.div
                        initial={{ opacity: 0, x: 50 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.8 }}
                        className="flex-1 text-left"
                    >
                        <div className="flex items-center gap-2 mb-6">
                            <div className="w-10 h-10 bg-[#F0F4FF] rounded-lg flex items-center justify-center">
                                <Lightbulb className="text-[#1B61FF] w-5 h-5" />
                            </div>
                            <span className="text-[#1B61FF] font-semibold text-sm">Testimonials</span>
                        </div>

                        <h2 className="text-[#1A1A1A] text-3xl lg:text-4xl font-bold mb-10 leading-tight">
                            Real Experiences. Real Results.
                        </h2>

                        <div className="flex gap-8">
                            {/* Blue Line */}
                            <div className="w-[2px] bg-[#1B61FF] relative shrink-0">
                                <motion.div
                                    initial={{ height: 0 }}
                                    whileInView={{ height: "100%" }}
                                    viewport={{ once: true }}
                                    transition={{ duration: 1 }}
                                    className="absolute inset-0 bg-[#1B61FF]"
                                />
                                <div className="absolute bottom-4 left-1/2 -translate-x-1/2 w-3 h-3 bg-[#1B61FF] rotate-45" />
                            </div>

                            <div className="flex flex-col w-full">
                                <Quote className="text-[#1B61FF] fill-[#1B61FF] w-10 h-10 mb-6 shrink-0" />

                                <div className="relative mb-12 min-h-[200px]">
                                    {/* Dot Indicator */}
                                    <div className="absolute -left-12 top-2">
                                        <div className="w-6 h-6 rounded-full border border-[#DDE6FF] flex items-center justify-center">
                                            <div className="w-1.5 h-1.5 rounded-full bg-[#1B61FF]" />
                                        </div>
                                    </div>
                                    <AnimatePresence mode="wait">
                                        <motion.div
                                            key={activeIndex}
                                            initial={{ opacity: 0, y: 10 }}
                                            animate={{ opacity: 1, y: 0 }}
                                            exit={{ opacity: 0, y: -10 }}
                                            transition={{ duration: 0.3 }}
                                        >
                                            <StarRating rating={displayTestimonials[activeIndex].rating} />
                                            <p className="text-[#666666] text-lg leading-relaxed max-w-xl mb-4">
                                                {displayTestimonials[activeIndex].text}
                                            </p>
                                            <p className="font-bold text-[#1A1A1A] text-base">
                                                {displayTestimonials[activeIndex].author}
                                            </p>
                                            <p className="text-[#888888] text-sm mb-3">
                                                {displayTestimonials[activeIndex].role} &mdash; {displayTestimonials[activeIndex].location}
                                            </p>
                                            <Link
                                                href={displayTestimonials[activeIndex].courseSlug}
                                                className="inline-block px-3 py-1 rounded-full text-xs font-bold bg-blue-100 text-blue-700 hover:bg-blue-200 transition-colors"
                                            >
                                                {displayTestimonials[activeIndex].course}
                                            </Link>
                                        </motion.div>
                                    </AnimatePresence>
                                </div>

                                {/* Author indicator dots & Navigation */}
                                <div className="flex items-center justify-between mt-auto">
                                    <div className="flex items-center gap-4">
                                        {displayTestimonials.map((t, i) => (
                                            <button
                                                key={i}
                                                type="button"
                                                aria-label={`View testimonial from ${t.author}`}
                                                onClick={() => setActiveIndex(i)}
                                                className={`w-10 h-10 rounded-full border-2 flex items-center justify-center font-bold text-xs transition-all cursor-pointer ${activeIndex === i ? "border-[#1B61FF] bg-[#1B61FF] text-white scale-110" : "border-gray-300 bg-gray-100 text-gray-500 hover:border-[#1B61FF]"}`}
                                            >
                                                {t.author.charAt(0)}
                                            </button>
                                        ))}
                                    </div>

                                    <div className="flex-grow mx-8 h-[1px] bg-gray-100 hidden sm:block" />

                                    <div className="flex gap-3 hidden sm:flex">
                                        <button
                                            onClick={prev}
                                            aria-label="Previous slide"
                                            className="w-12 h-12 rounded-full bg-[#DDE6FF] cursor-pointer flex items-center justify-center text-[#1B61FF] hover:bg-[#1B61FF] hover:text-white transition-all shadow-sm"
                                        >
                                            <ChevronLeft size={24} aria-hidden="true" />
                                        </button>
                                        <button
                                            onClick={next}
                                            aria-label="Next slide"
                                            className="w-12 h-12 rounded-full bg-[#1B61FF] cursor-pointer flex items-center justify-center text-white hover:bg-blue-600 transition-all shadow-md"
                                        >
                                            <ChevronRight size={24} aria-hidden="true" />
                                        </button>
                                    </div>
                                </div>

                                {/* See All CTA */}
                                <div className="mt-8">
                                    <Link
                                        href="/testimonials"
                                        className="inline-flex items-center gap-2 text-sm font-bold text-[#1B61FF] hover:underline"
                                    >
                                        See All Student Stories →
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </motion.div>
                </div>

                {/* Popular Categories Section */}
                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6 }}
                    className="pt-20 border-t border-gray-100 text-left"
                >
                    <h3 className="text-[#1A1A1A] font-bold text-lg mb-8 uppercase tracking-wide">Popular Categories</h3>

                    <div className="flex flex-col gap-4 overflow-x-auto md:overflow-x-visible">
                        {rows.map((row, rowIdx) => (
                            <div key={rowIdx} className="flex flex-nowrap md:flex-wrap items-center gap-3">
                                {row.map((cat) => (
                                    <Link
                                        key={cat.href}
                                        href={cat.href}
                                        className="flex items-center gap-2 px-5 py-2.5 bg-[#F3F5F7] hover:bg-[#E9ECEF] transition-colors rounded-full whitespace-nowrap group shrink-0 md:shrink"
                                    >
                                        <span className="text-base leading-none">{cat.icon}</span>
                                        <span className="font-semibold text-[#1A1A1A] text-sm">{cat.label}</span>
                                    </Link>
                                ))}
                            </div>
                        ))}
                    </div>
                </motion.div>
            </div>
        </section>
    );
}

